export default "__VITE_ASSET__Cwls0p49__"